import qs from "qs"

interface QueryParams {
  uuid: string
  code: string
  /** @deprecated: V2 tmp password */
  tmp: string
  /** @deprecated: V2 token */
  token: string
}

export function getQuery(): QueryParams {
  const {uuid, token, tmp, code} = qs.parse(window.location.href.split("?")[1])
  return {uuid, token, tmp, code}
}
